import {Dto} from "common";

export class IkdcResultsModel extends Dto {
    public score;

    deserialize(input: any): this {
        Object.assign(this, input);
        return this;
    }

}
